import styled from '@emotion/styled';
import { useTranslation } from '@hotjar/translations';
import { Link, tokens } from '@hotjar/hotsauce';
import type { FeedbackData } from '@hotjar/webapp/domains/activation/featured-insights/types';
import { epochDate } from '@hotjar/webapp/lib/time';
import { DetailsDefinition, DetailsLine, DetailsTitle, PageLinkLine } from '../../shared/styles';

const FeedbackRecordingLink = styled(Link)`
  color: ${tokens.color.text_light};
  font-size: 12px;
  text-decoration: none;
  display: flex;
  align-items: center;

  &:hover {
    color: ${tokens.color.text_light};
  }
`;

export const PageLink = styled(FeedbackRecordingLink)`
  display: inline;
  margin-left: 0.5ch;
  color: ${tokens.color.text_light};
  font-size: 12px;
  text-decoration: underline;

  &:hover {
    text-decoration: revert;
  }
`;

export const FeedbackSidebar = ({ data }: { data: FeedbackData }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.feedback.response')}:
        </DetailsTitle>
        <DetailsDefinition>{`#${data.index}`}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.feedback.id')}:
        </DetailsTitle>
        <DetailsDefinition>{data.feedbackWidgetId}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.feedback.date')}:
        </DetailsTitle>
        <DetailsDefinition>{epochDate(data.created, 'DD MMM YYYY')}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.feedback.country')}:
        </DetailsTitle>
        <DetailsDefinition>{data.countryName}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.feedback.user-id')}:
        </DetailsTitle>
        <DetailsDefinition>{data.shortVisitorUuid}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.feedback.device')}:
        </DetailsTitle>
        <DetailsDefinition>{data.device}</DetailsDefinition>
      </DetailsLine>

      {/* <DetailsLine>
        <FeedbackRecordingLink kind="standalone" isExternal href={data.responseUrl}>
          {data?.responseUrl.length > 0
            ? t(
                'activation:space-overview.for-you.featured-insights.slider.slide.feedback.recording-available',
              )
            : t(
                'activation:space-overview.for-you.featured-insights.slider.slide.feedback.recording-not-available',
              )}
        </FeedbackRecordingLink>
      </DetailsLine> */}
      <PageLinkLine>
        {t('activation:space-overview.for-you.featured-insights.slider.slide.feedback.page')}:
        <PageLink href={data.responseUrl} kind="standalone" isExternal>
          {data.responseUrl || ''}
        </PageLink>
      </PageLinkLine>
    </>
  );
};
